import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { LegacyImage } from "components";
import { useAnchor } from "hooks";
import { HeroSubsection3Content } from "types/graphql/generated";

interface Props {
  content: HeroSubsection3Content;
}

const HeroSubsection3: VFC<Props> = withErrorBoundary(({ content: { integrationCard, image } }) => {
  useAnchor("hero-subsection3");

  return (
    <StyledHeroSubsection3 className="hero-subsection3 Content">
      <div className="HeroSubsection3 ">
        <LegacyImage
          layout="fill"
          objectFit="cover"
          objectPosition="50% 50%"
          src={image.data.image.src}
          alt={image.data.image.alt}
          className="HeroSubsection3__image"
        />
        <LegacyImage
          layout="fill"
          objectFit="cover"
          src={integrationCard.data.integrationCard.src}
          alt={integrationCard.data.integrationCard.alt}
          className="HeroSubsection3__integrationCard"
        />
      </div>
    </StyledHeroSubsection3>
  );
}, {});

const StyledHeroSubsection3 = styled.section`
  margin-bottom: -274px;
  margin-top: -64px;
  padding-top: 64px;

  .HeroSubsection3 {
    display: flex;
  }

  .HeroSubsection3__image {
    position: relative;
    height: 450px;
    width: 100%;
    top: 0;
    right: 0;
  }

  .HeroSubsection3__integrationCard {
    position: relative;
    min-width: 352px;
    height: 450px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    margin-bottom: -154px;

    .HeroSubsection3__image {
      height: 330px;
      width: 100%;
      top: 0;
      right: 0;
    }

    .HeroSubsection3__integrationCard {
      min-width: 258px;
      height: 330px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .HeroSubsection3__integrationCard {
      display: none;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    &.Content {
      padding: 0;
      margin-top: 0;
    }

    .HeroSubsection3__image {
      height: 250px;
    }
  }
`;

gql`
  fragment HeroSubsection3Content on ComponentHeroHeroSubsection3 {
    image {
      data {
        image: attributes {
          src: hash
          width
          height
          alt: alternativeText
        }
      }
    }
    integrationCard {
      data {
        integrationCard: attributes {
          src: hash
          width
          height
          alt: alternativeText
        }
      }
    }
  }
`;

export { HeroSubsection3 };
export type { Props as HeroSubsection3Props };
